module.exports = __webpack_public_path__ + "static/media/fitso.9bc79ea4.png";